import { useQuery } from "react-query";
import { getNumberOfKeys } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useNumberOfKeys = () => {
  const { data, isLoading, refetch } = useQuery("GetNumberOfKeys", getNumberOfKeys, {
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, refetch };
};
